import { NgModule } from '@angular/core';
import { AttendanceFaceRecognizeApi } from '../thermal/services/attendance-face-recognize.api';
import { AccessAuthorizationApiProvider } from './access-management/access-authorization-api';
import { AccessManagementApiProvider } from './access-management/access-management-api';
import { ActivityProvider } from './activity-recording/activity';
import { AnnouncementProvider } from './announcement/announcement';
import { GDAttendanceCorrectionApiProvider } from './attendance/gd-attendance-correction-api';
import { HolidayApiProvider } from './attendance/holiday-api';
import { ShiftScheduleApiProvider } from './attendance/shift-schedule-api';
import { ElearningProvider } from './elearning/elearning';
import { EmployeeCareerProvider } from './employee-career/employee-career';
import { ARAPAdjustmentApi } from './erp/arapadjustment.api';
import { BookEntryReqApi } from './erp/bookentryreq.api';
import { BookEntryReqDeclareApi } from './erp/bookentryreqdeclare.api';
import { BookEntrySettlementApi } from './erp/bookentrysettlement.api';
import { BookEntryTransApi } from './erp/bookentrytrans.api';
import { ConvertPrepayApi } from './erp/convertprepay.api';
import { CustomerApi } from './erp/customer.api';
import { DepositSettlementApi } from './erp/depositsettlement.api';
import { InventoryApi } from './erp/inventory.api';
import { PayrollJournalReqApi } from './erp/payrolljournalreq.api';
import { PurchaseContractApi } from './erp/purchasecontract.api';
import { PurchaseDcNoteApi } from './erp/purchasedcnote.api';
import { PurchaseInvoiceApi } from './erp/purchaseinvoice.api';
import { PurchaseOrderApi } from './erp/purchaseorder.api';
import { PurchaseRequestApi } from './erp/purchaserequest.api';
import { PurchaseReturnApi } from './erp/purchasereturn.api';
import { PurchaseReturnRequisitionApi } from './erp/purchasereturnrequisition.api';
import { SalesApi } from './erp/sales.api';
import { SegmentApi } from './erp/segment.api';
import { BenefitMarketplaceApi } from './flexible-benefit/benefit-marketplace/benefit-marketplace.api';
import { ClaimApiOnly } from './gd-all-in-one/services/claim.api';
import { ReportProblemsApi } from "./gd-all-in-one/services/report-problems.api";
import { RequestInboxApi } from "./gd-all-in-one/services/request-inbox.api";
import { SettingApi } from "./gd-all-in-one/services/setting.api";
import { SFCareerApi } from "./gd-all-in-one/services/sf-career.api";
import { SmartfeedNestApi } from './gd-all-in-one/services/sf-smartfeed.api';
import { TaskFeedbackApi } from "./gd-all-in-one/services/task-feedback.api";
import { AddressSf6Provider } from './gd-integrated/services/address-sf6';
import { ApplicantSF6Api } from './gd-integrated/services/applicant-sf6.api';
import { BankAccountSf6Provider } from './gd-integrated/services/bank-account-sf6';
import { BankDistributionSf6Api } from './gd-integrated/services/bank-distribution-sf6.api';
import { CertificationSf6Api } from './gd-integrated/services/certification-sf6';
import { ClaimApi } from './gd-integrated/services/claim.api';
import { CompanyGroupSf6Api } from './gd-integrated/services/company-group-sf6.api';
import { CompanySettingSf6Api } from './gd-integrated/services/company-setting';
import { CompanyfacilityApi } from './gd-integrated/services/companyfacility.api';
import { ContactSf6Provider } from './gd-integrated/services/contact-sf6';
import { CorrectionApi } from "./gd-integrated/services/correction.api";
import { CourseSf6Api } from './gd-integrated/services/course.api';
import { CustomFieldSf6Api } from './gd-integrated/services/custom-field-sf6.api';
import { DocumentControlSf6Api } from './gd-integrated/services/documentcontrol.api';
import { EducationSf6Provider } from './gd-integrated/services/education-sf6';
import { EmergencySf6Provider } from './gd-integrated/services/emergency-sf6';
import { EmpPerformanceSf6Provider } from './gd-integrated/services/emp-performance-sf6.api';
import { EmployeeChecklistSf6Api } from './gd-integrated/services/employee-checklist-sf6.api';
import { EmployeeLoanReportApi } from './gd-integrated/services/employee-loan-report.api';
import { EmploymentInfoSf6Api } from './gd-integrated/services/employment-info-sf6.api';
import { FamilySf6Provider } from './gd-integrated/services/family-sf6';
import { InsuranceSf6Provider } from './gd-integrated/services/insurance-sf6';
import { Interestf6Api } from './gd-integrated/services/interest.api';
import { JobexpSf6Provider } from './gd-integrated/services/jobexp-sf6';
import { LangskillSf6Api } from './gd-integrated/services/langskill.api';
import { LeaveCalendarApi } from './gd-integrated/services/leave-calendar.api';
import { LeaveSf6Api } from "./gd-integrated/services/leave-sf6.api";
import { LetterSf6Api } from './gd-integrated/services/letter.api';
import { LoanRequestReportApi } from './gd-integrated/services/loan-request-report.api';
import { MedicalSf6Provider } from './gd-integrated/services/medical-sf6';
import { MedicalhistorySf6Api } from './gd-integrated/services/medicalhistory.api';
import { OhsaHistorySf6Api } from './gd-integrated/services/ohsa-history-sf6.api';
import { OnDutyCancellationApi } from './gd-integrated/services/on-duty-cancellation.api';
import { OnDutyDeclarationApi } from './gd-integrated/services/on-duty-declaration.api';
import { OnDutyApi } from './gd-integrated/services/on-duty.api';
import { OrgactivSf6Api } from './gd-integrated/services/orgactiv-sf6.api';
import { OvertimeCancelApi } from './gd-integrated/services/overtime-cancel.api';
import { OvertimeApi } from './gd-integrated/services/overtime.api';
import { PerformanceEvaluationApi } from './gd-integrated/services/performance-evaluation.api';
import { PerformanceMonitoringApi } from './gd-integrated/services/performance-monitoring.api';
import { PerformancePlanningApi } from './gd-integrated/services/performance-planning.api';
import { PersonalSf6Provider } from './gd-integrated/services/personal-sf6';
import { SF6SPolicyApi } from './gd-integrated/services/sf6s-policy.api';
import { ProfileAwardsIntegratedApi } from './gd-integrated/services/profile-awards.api';
import { CompetencyApiProvider } from './gd-integrated/services/profile-competency.api';
import { PsychologicaltestSf6Api } from './gd-integrated/services/psychologicaltest-sf6.api';
import { Question360Api } from './gd-integrated/services/question360.api';
import { ReferenceSf6Api } from './gd-integrated/services/reference.api';
import { RequestForApi } from "./gd-integrated/services/request-for.api";
import { RequestInboxIntegratedApi } from './gd-integrated/services/request-inbox.api';
import { RequestforReportApi } from './gd-integrated/services/requestfor-report.api';
import { ResourceBookingNestApi } from './gd-integrated/services/resource-booking.api';
import { ServiceagreementSf6Api } from './gd-integrated/services/serviceagreement-sf6.api';
import { Sf6EmployeeDisciplinaryProvider } from './gd-integrated/services/sf6-employee-disciplinary.api';
import { Sf6EmployeeTrainingRecordProvider } from './gd-integrated/services/sf6-employeetrainingrecord.api';
import { ShiftscheduleApi } from "./gd-integrated/services/shiftschedule.api";
import { SkillSf6Api } from './gd-integrated/services/skill.api';
import { StorageApi } from './gd-integrated/services/storage.api';
import { ActivityReportApi } from "./gd-only/services/activity-report.api";
import { ActivityApi } from "./gd-only/services/activity.api";
import { AddressNestApi } from './gd-only/services/address.api';
import { ApprovalSettingApi } from './gd-only/services/approval-setting.api';
import { AttWorkLocationApi } from "./gd-only/services/att-work-location.api";
import { AttendancesFaceApi } from './gd-only/services/attendance-face.api';
import { AttendanceItcsApi } from './gd-only/services/attendance-itcs.api';
import { AttendanceLocationReportApi } from './gd-only/services/attendance-location-report.api';
import { AttendanceLocationApi } from './gd-only/services/attendance-location.api';
import { AttendanceMachineApi } from './gd-only/services/attendance-machine.api';
import { AttendanceReportApi } from './gd-only/services/attendance-report.api';
import { AttendanceSummaryApi } from "./gd-only/services/attendance-summary.api";
import { AttendanceApi } from './gd-only/services/attendance.api';
import { AttendancesApi } from "./gd-only/services/attendances.api";
import { AuthApi } from "./gd-only/services/auth.api";
import { BusinessTripReportApi } from './gd-only/services/business-trip-report.api';
import { BusinesstripApi } from './gd-only/services/businesstrip.api';
import { CalendarApi } from './gd-only/services/calendar.api';
import { CareerReportApi } from './gd-only/services/career-report.api';
import { CareerApi } from './gd-only/services/career.api';
import { ClaimReportApi } from './gd-only/services/claim-report.api';
import { ContactNestApi } from './gd-only/services/contact.api';
import { CoreAuthApi } from './gd-only/services/core-auth.api';
import { CostCenterNestApi } from './gd-only/services/cost-center.api';
import { DepartmentApi } from "./gd-only/services/department.api";
import { EducationsNestApi } from './gd-only/services/educations.api';
import { EdutitleApi } from './gd-only/services/edutitle.api';
import { EmergencyContactApi } from './gd-only/services/emergency-contact.api';
import { EmergencysNestApi } from './gd-only/services/emergencys.api';
import { EmpOvtPHReportApi } from './gd-only/services/emp-ovt-ph-report.api';
import { EmpOvtReportApi } from "./gd-only/services/emp-ovt-report.api";
import { EmpStatusSettingApi } from './gd-only/services/emp-status-setting.api';
import { EmployeeMoodApi } from './gd-only/services/employee-mood.api';
import { EmployeeRequestReportApi } from './gd-only/services/employee-request-report.api';
import { EmployeeRequestNestApi } from './gd-only/services/employee-request.api';
import { EmployeesApi } from "./gd-only/services/employees.api";
import { FaceThermalDashboardUserLoginApi } from './gd-only/services/face-thermal-dashboard-users-login.api';
import { FaceThermalUserApi } from './gd-only/services/face-thermal-user.api';
import { FaceThermalApi } from './gd-only/services/face-thermal.api';
import { FamilyNestApi } from './gd-only/services/family.api';
import { FeedServiceNestApi } from './gd-only/services/feed-service.api';
import { FingerprintApi } from './gd-only/services/fingerprint.api';
import { GamificationNestApi } from './gd-only/services/gamification.api';
import { GdEventReportApi } from './gd-only/services/gd-event-report.api';
import { GreatdayApi } from './gd-only/services/greatday.api';
import { HeadCountReportApi } from "./gd-only/services/head-count-report.api";
import { InvitationMemberNestApi } from './gd-only/services/invitation-member';
import { JobGradeApi } from "./gd-only/services/job-grade.api";
import { JobexpsNestApi } from './gd-only/services/Jobexps.api';
import { KioskApi } from './gd-only/services/kiosk.api';
import { LeaderBoardNestApi } from './gd-only/services/leaderboard.api';
import { LeaveApi } from './gd-only/services/leave.api';
import { LookupApi } from './gd-only/services/lookup.api';
import { MarketplaceApi } from './gd-only/services/marketplace.api';
import { MedicalsNestApi } from './gd-only/services/medicals.api';
import { MultiBankApi } from './gd-only/services/multibank.api';
import { NationalityApi } from './gd-only/services/nationality.api';
import { NewActivityApi } from "./gd-only/services/new-activity.api";
import { OnBoardingApi } from './gd-only/services/on-boarding.api';
import { OvertimeCancelRequestApi } from './gd-only/services/overtime-cancel-request.api';
import { OvertimeReportApi } from "./gd-only/services/overtime-report.api";
import { PanicApi } from './gd-only/services/panic.api';
import { PerformanceReportApi } from './gd-only/services/performance-report.api';
import { PersonalReportApi } from "./gd-only/services/personal-report.api";
import { PersonalNestApi } from './gd-only/services/personal.api';
import { PositionNestApi } from './gd-only/services/position.api';
import { PostServiceNestApi } from './gd-only/services/post-service.api';
import { RegistrationsNestApi } from './gd-only/services/registrations.api';
import { ReligionApi } from './gd-only/services/religion.api';
import { ReportPreviewApi } from "./gd-only/services/report-preview.api";
import { ReportApi } from "./gd-only/services/report.api";
import { SettingOnboardingApi } from "./gd-only/services/setting-onboarding.api";
import { SfApprovalSettingApiNest } from "./gd-only/services/sf-approval-setting.api";
import { SfAttendanceApi } from './gd-only/services/sf-attendance';
import { SfAuthenticatorApi } from './gd-only/services/sf-authenticator.api';
import { SfBusinessTripDeclarationApi } from './gd-only/services/sf-business-trip-declaration.api';
import { SfChangePrivaciesApi } from "./gd-only/services/sf-change-privacies.api";
import { SfChangeSpvApi } from "./gd-only/services/sf-change-spv.api";
import { SfClaimRequestNestApi } from './gd-only/services/sf-claim-request.api';
import { SfCompanyApi } from "./gd-only/services/sf-company.api";
import { SfFormulaApi } from "./gd-only/services/sf-formula.api";
import { SfGenerateLeaveBalanceApi } from "./gd-only/services/sf-generate-leave-balance.api";
import { SfLeaveCancelRequestApi } from "./gd-only/services/sf-leave-cancel-request.api";
import { SfLeaveRequestApi } from "./gd-only/services/sf-leave-request.api";
import { SfMassLeaveApi } from "./gd-only/services/sf-mass-leave.api";
import { SfOnDutyApi } from './gd-only/services/sf-on-duty.api';
import { SfpayslipApi } from './gd-only/services/sf-payslip.api';
import { SfProfileApi } from "./gd-only/services/sf-profile.api";
import { SfRequestInboxNestApi } from './gd-only/services/sf-request-inbox.api';
import { ShiftDailyApi } from './gd-only/services/shift-daily.api';
import { ShiftScheduleRequestApi } from './gd-only/services/shift-schedule-request.api';
import { ShiftReportApi } from "./gd-only/services/shiftschedule-report.api";
import { SocialManagementApi } from './gd-only/services/social-management.api';
import { SubscriptionNestApi } from './gd-only/services/subscription.api';
import { SunfishNestApi } from "./gd-only/services/sunfish.api";
import { SurveyServiceNestApi } from './gd-only/services/survey-service-nest-api';
import { SurveyServiceV2NestApi } from './gd-only/services/survey-serviceV2-nest-api';
import { SurveySettingApi } from "./gd-only/services/survey-setting.api";
import { SuspectAttFaceReportApi } from "./gd-only/services/suspect-att-face-report.api";
import { SuspectAttendanceReportApi } from "./gd-only/services/suspect-attendance-report.api";
import { TaskFeedbackReportApi } from './gd-only/services/task-feedback-report.api';
import { TimesheetReportApi } from './gd-only/services/timesheet-report.api';
import { TimezoneApi } from './gd-only/services/timezone.api';
import { TrackerReportApi } from './gd-only/services/tracker-report.api';
import { TrackerApi } from "./gd-only/services/tracker.api";
import { TtadempLocationApi } from "./gd-only/services/ttademp-location.api";
import { ViewAbswReportApi } from "./gd-only/services/view-absw-report.api";
import { WorklocationNestApi } from './gd-only/services/worklocation.api';
import { HelpCenterNestApi } from './help-center/help-center';
import { HomeFeedProvider } from './home-feed/home-feed';
import { IntegrationApi } from './integration/integration';
import { LeaveBalanceApiProvider } from './leave/leave-balance-api';
import { LeaveSettingtApiProvider } from './leave/leave-setting-api';
import { LoanProvider } from './loan/loan-provider';
import { MakeIdCardApiProvider } from './make-id-card/make-id-card-api';
import { NestApiProvider } from './nest-api';
import { NestAuthProvider } from './nest-auth';
import { NestResponsesProvider } from './nest-responses';
import { OvertimeCancelRequestApiProvider } from './overtime/overtime-cancel-request-api';
import { OvertimeRequestApiProvider } from './overtime/overtime-request-api';
import { ThawiProvider } from './payroll/50thawi/50thawi';
import { BankMalayReportApi } from './payroll/bank-malay-report.api';
import { BankReportProvider } from './payroll/bank-report/bank-report';
import { BanKThaiReportProvider } from './payroll/bank-thai-report/bank-thai-report';
import { BpjsReportProvider } from './payroll/bpjs-report/bpjs-report';
import { ComponentSettingApi } from './payroll/component-setting.api';
import { CostCenterThaiProvider } from './payroll/costCenterThai/cost.center.thai';
import { EaSettingApi } from './payroll/ea-setting.api';
import { EisSettingApi } from './payroll/eis-setting.api';
import { EpfReportApi } from './payroll/epf-report.api';
import { EpfSettingApi } from './payroll/epf-setting.api';
import { FileTransferProvider } from './payroll/file-transfer/file-transfer';
import { Sf6Spt1721A1Provider } from './payroll/form-1721-a-1/sf6-spt1721a1.api';
import { JobGradePayrollProvider } from './payroll/job-grade-payroll/job-grade-payroll';
import { PayProcessProvider } from './payroll/pay-process/pay-process';
import { PayrollHistoryProvider } from './payroll/payroll-history/payroll-history-provider';
import { PayrollInsuranceReportProvider } from './payroll/payroll-insurance-report/payroll-insurance-report';
import { PayrollProcessMalayReportApi } from './payroll/payroll-process-malay-report.api';
import { PayrollProcessReportProvider } from './payroll/payroll-process-report/payroll-process-report';
import { PayrollProcessThaiReportProvider } from './payroll/payroll-process-thai-report/payroll-process-thai-report';
import { PayrollRegisterReportProvider } from './payroll/payroll-register-report/payroll-register-report';
import { PayrollSptReportProvider } from './payroll/payroll-spt-report/payroll-spt-report';
import { PayrollTaxReportProvider } from './payroll/payroll-tax-report/payroll-tax-report';
import { Pnd1Provider } from './payroll/pnd1/pnd1';
import { Pnd1korProvider } from './payroll/pnd1kor/pnd1kor';
import { Pnd91Api } from './payroll/pnd91.api';
import { ProcessTemplateProvider } from './payroll/process-template/process-template';
import { QueueServiceProvider } from './payroll/queue-service/queueService-provider';
import { ReportLoryorApi } from './payroll/report-loryor.api';
import { ReportvariableSettingApi } from './payroll/reportvariable-setting.api';
import { SfCompanyProvider } from './payroll/sf-company/sf-company';
import { SfEmployeePayrollDataProvider } from './payroll/sf-employee-payroll-data/sf-employee-payroll-data';
import { SfPayPeriodsProvider } from './payroll/sf-payperiods/sf-payperiods';
import { SfPayprocessApi } from './payroll/sf-payprocess/sf-payprocess.api';
import { SfPayrollProvider } from './payroll/sf-payroll/sf-payroll';
import { SfPayrollWizardProvider } from './payroll/sf-payroll/sf-payroll-wizard';
import { SfPayrollsProvider } from './payroll/sf-payroll/sf-payrolls';
import { SfPayslipProvider } from './payroll/sf-payslip/sf-payslip';
import { SfPayslipGdoProvider } from './payroll/sf-payslip/sf-payslip-gdo';
import { SocsoReportApi } from './payroll/socso-report.api';
import { SocsoSettingApi } from './payroll/socso-setting.api';
import { SsoBranchProvider } from './payroll/sso-branch/sso-branch';
import { SsoReportProvider } from './payroll/sso-report/sso-report';
import { StdFormulaReportApi } from './payroll/std-formula-report.api';
import { TaxexemptionApi } from './payroll/taxexemption.api';
import { TaxpercentageSettingApi } from './payroll/taxpercentage-setting.api';
import { WorkmenReportProvider } from './payroll/workmen-report/workmen-report';
import { PollingProvider } from './polling/polling';
import { PollingSf6Provider } from './polling/polling-sf6';
import { StandardizedDataAPiProvider } from './setting/standardized-data/standardized-data';
import { SfrequestinboxProvider } from './sfrequestinbox/sfrequestinbox';
import { WorkLocationProvider } from './standardized-data/work-location/work-location';
import { StorageProvider } from './storage/storage';
import { SubscriptionProvider } from './subscription/SubscriptionProvider';
import { TrainingHistoryApiProvider } from './training/training-history-api';
import { ApiWorkLocation } from './work-location/work-location';
import { WorkFlowApiProvider } from './workflow/workflow-api';
import { AcrReportApi } from './gd-only/services/acr-report.api';
import { OvtCancelReportApi } from './gd-only/services/overtime-cancel-report.api';
import { SessionManagementApi } from "./gd-only/services/session-management.api";
import { SF7Api } from './sf7/core.api';
import { BasePhotoApi } from './gd-all-in-one/services/base-photo.api';
import { PolicyApi } from './gd-only/services/policy.api';
import { WorklocConfirmationNestApi } from './gd-only/services/workloc-confirmation.api';
import { BuilderApi } from './builder/builder.api';

@NgModule({
        declarations: [],
        providers: [
                AcrReportApi,
                OvtCancelReportApi,
                PersonalNestApi,
                ContactNestApi,
                AddressNestApi,
                EmployeeRequestNestApi,
                EmergencysNestApi,
                EducationsNestApi,
                MedicalsNestApi,
                JobexpsNestApi,
                FamilyNestApi,
                RequestInboxApi,
                SfMassLeaveApi,
                SfLeaveCancelRequestApi,
                SFCareerApi,
                DepartmentApi,
                PositionNestApi,
                AuthApi,
                SessionManagementApi,
                TtadempLocationApi,
                SfGenerateLeaveBalanceApi,
                SfLeaveRequestApi,
                EmployeesApi,
                SfProfileApi,
                LeaveSf6Api,
                TaskFeedbackApi,
                JobGradeApi,
                SfChangePrivaciesApi,
                AttWorkLocationApi,
                SfOnDutyApi,
                ShiftDailyApi,
                SfBusinessTripDeclarationApi,
                RequestForApi,
                ReportApi,
                SfpayslipApi,
                SettingApi,
                SfChangeSpvApi,
                SfCompanyApi,
                BusinesstripApi,
                ReportPreviewApi,
                ActivityReportApi,
                SurveyServiceNestApi,
                SurveyServiceV2NestApi,
                OvertimeApi,
                OvertimeCancelApi,
                HeadCountReportApi,
                FeedServiceNestApi,
                PostServiceNestApi,
                EmpOvtReportApi,
                ReportProblemsApi,
                ProfileAwardsIntegratedApi,
                PersonalSf6Provider,
                ContactSf6Provider,
                AddressSf6Provider,
                EmergencySf6Provider,
                FamilySf6Provider,
                EducationSf6Provider,
                MedicalSf6Provider,
                JobexpSf6Provider,
                BankAccountSf6Provider,
                InsuranceSf6Provider,
                MakeIdCardApiProvider,
                ShiftScheduleApiProvider,
                LeaveSettingtApiProvider,
                LeaveBalanceApiProvider,
                OvertimeRequestApiProvider,
                WorkFlowApiProvider,
                OvertimeCancelRequestApiProvider,
                HolidayApiProvider,
                AttendanceApi,
                AnnouncementProvider,
                GDAttendanceCorrectionApiProvider,
                NestAuthProvider,
                NestApiProvider,
                NestResponsesProvider,
                PayProcessProvider,
                PayrollProcessReportProvider,
                PayrollTaxReportProvider,
                BankReportProvider,
                SfPayrollsProvider,
                AccessManagementApiProvider,
                AccessAuthorizationApiProvider,
                SfPayslipProvider,
                HomeFeedProvider,
                SfPayprocessApi,
                PayrollHistoryProvider,
                QueueServiceProvider,
                SfPayrollWizardProvider,
                SfPayPeriodsProvider,
                JobGradePayrollProvider,
                TrainingHistoryApiProvider,
                SsoBranchProvider,
                SfPayslipGdoProvider,
                ElearningProvider,
                PollingSf6Provider,
                CompetencyApiProvider,
                Sf6EmployeeDisciplinaryProvider,
                Sf6EmployeeTrainingRecordProvider,
                ActivityProvider,
                StorageProvider,
                ClaimApiOnly,
                StandardizedDataAPiProvider,
                SfrequestinboxProvider,
                PollingProvider,
                ApiWorkLocation,
                RequestInboxIntegratedApi,
                StorageApi,
                EmployeeCareerProvider,
                AttendanceLocationApi,
                WorkLocationProvider,
                PayrollRegisterReportProvider,
                PayrollInsuranceReportProvider,
                BanKThaiReportProvider,
                FileTransferProvider,
                Pnd1Provider,
                SsoReportProvider,
                Pnd1korProvider,
                ThawiProvider,
                WorkmenReportProvider,
                PayrollProcessThaiReportProvider,
                ProcessTemplateProvider,
                SfPayrollProvider,
                SfCompanyProvider,
                SfEmployeePayrollDataProvider,
                PayrollSptReportProvider,
                BpjsReportProvider,
                OvertimeReportApi,
                ClaimApi,
                MultiBankApi,
                SfAuthenticatorApi,
                TrackerApi,
                NewActivityApi,
                ActivityApi,
                SunfishNestApi,
                LoanProvider,
                CostCenterThaiProvider,
                AttendancesApi,
                Sf6Spt1721A1Provider,
                GamificationNestApi,
                OnDutyApi,
                SF6SPolicyApi,
                OnDutyCancellationApi,
                OnDutyDeclarationApi,
                SfFormulaApi,
                ClaimReportApi,
                CorrectionApi,
                EmployeeRequestReportApi,
                ApprovalSettingApi,
                CareerApi,
                WorklocationNestApi,
                CostCenterNestApi,
                AttendanceReportApi,
                AttendanceSummaryApi,
                ViewAbswReportApi,
                SfClaimRequestNestApi,
                SmartfeedNestApi,
                BusinessTripReportApi,
                ShiftscheduleApi,
                CareerReportApi,
                SuspectAttendanceReportApi,
                SuspectAttFaceReportApi,
                HelpCenterNestApi,
                KioskApi,
                PanicApi,
                EmergencyContactApi,
                ResourceBookingNestApi,
                FaceThermalApi,
                TaskFeedbackReportApi,
                ComponentSettingApi,
                FaceThermalUserApi,
                FaceThermalDashboardUserLoginApi,
                EmpPerformanceSf6Provider,
                SubscriptionNestApi,
                RegistrationsNestApi,
                LeaderBoardNestApi,
                TaxpercentageSettingApi,
                FaceThermalDashboardUserLoginApi,
                EpfSettingApi,
                SocsoSettingApi,
                TaxexemptionApi,
                LeaderBoardNestApi,
                SfRequestInboxNestApi,
                EisSettingApi,
                SfApprovalSettingApiNest,
                ReportvariableSettingApi,
                CertificationSf6Api,
                EaSettingApi,
                PerformanceReportApi,
                AttendanceMachineApi,
                PurchaseRequestApi,
                PurchaseReturnRequisitionApi,
                PurchaseReturnApi,
                PurchaseInvoiceApi,
                OnBoardingApi,
                PurchaseContractApi,
                PurchaseDcNoteApi,
                Pnd91Api,
                ReportLoryorApi,
                EpfReportApi,
                CompanyfacilityApi,
                BankDistributionSf6Api,
                BookEntryReqApi,
                BookEntryTransApi,
                BookEntryReqDeclareApi,
                PayrollProcessMalayReportApi,
                BookEntrySettlementApi,
                DepositSettlementApi,
                SegmentApi,
                TimesheetReportApi,
                InvitationMemberNestApi,
                PurchaseOrderApi,
                ARAPAdjustmentApi,
                GdEventReportApi,
                ConvertPrepayApi,
                StdFormulaReportApi,
                SalesApi,
                BankMalayReportApi,
                EmployeeMoodApi,
                InventoryApi,
                ShiftScheduleRequestApi,
                LetterSf6Api,
                SkillSf6Api,
                Interestf6Api,
                CalendarApi,
                PayrollJournalReqApi,
                AttendanceItcsApi,
                CompanySettingSf6Api,
                CourseSf6Api,
                LangskillSf6Api,
                MedicalhistorySf6Api,
                SubscriptionProvider,
                SocsoReportApi,
                DocumentControlSf6Api,
                ReferenceSf6Api,
                EmploymentInfoSf6Api,
                CompanyGroupSf6Api,
                EmployeeChecklistSf6Api,
                ServiceagreementSf6Api,
                OhsaHistorySf6Api,
                CustomFieldSf6Api,
                PsychologicaltestSf6Api,
                AttendancesFaceApi,
                OrgactivSf6Api,
                FingerprintApi,
                ReligionApi,
                NationalityApi,
                MarketplaceApi,
                TrackerReportApi,
                CustomerApi,
                LookupApi,
                LoanRequestReportApi,
                EmployeeLoanReportApi,
                RequestforReportApi,
                GreatdayApi,
                LeaveCalendarApi,
                LeaveApi,
                TimezoneApi,
                AttendanceFaceRecognizeApi,
                PerformancePlanningApi,
                Question360Api,
                PerformanceEvaluationApi,
                ShiftReportApi,
                SettingOnboardingApi,
                PersonalReportApi,
                BenefitMarketplaceApi,
                PerformanceMonitoringApi,
                SurveySettingApi,
                IntegrationApi,
                AttendanceLocationReportApi,
                CoreAuthApi,
                OvertimeCancelRequestApi,
                EmpOvtPHReportApi,
                EmpStatusSettingApi,
                EdutitleApi,
                ApplicantSF6Api,
                SocialManagementApi,
                SfAttendanceApi,
                SF7Api,
                BasePhotoApi,
                PolicyApi,
                WorklocConfirmationNestApi,
                BuilderApi
        ]
})
export class NestApiModule {
}



// WEBPACK FOOTER //
// ./src/shared/nestjs/nest-api.module.ts